import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/lib/api";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ClientDashboard from "@/pages/ClientDashboard";
import NewRequest from "@/pages/NewRequest";
import RequestDetail from "@/pages/RequestDetail";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRequestDetail from "@/pages/AdminRequestDetail";
import AdminCalendar from "@/pages/AdminCalendar";
import AdminTeam from "@/pages/AdminTeam";
import AdminShowcase from "@/pages/AdminShowcase";
import WorkerHome from "@/pages/WorkerHome";
import WorkerJob from "@/pages/WorkerJob";
import AreaPage from "@/pages/AreaPage";
import Page365 from "@/pages/Page365";
import HomeFolder, { HomesList } from "@/pages/HomeFolder";
import { LocaleProvider } from "@/i18n";

const CUSTOMER = ["customer"], ADMIN = ["admin"], FIELD = ["worker", "partner"];

function Guard({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-sm text-ink/50">Caricamento…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
}

export default function App() {
  return (
    <LocaleProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/365" element={<Page365 />} />
          <Route path="/casa-e-villa" element={<AreaPage />} />
          <Route path="/cura-degli-interni" element={<AreaPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/app" element={<Guard roles={CUSTOMER}><ClientDashboard /></Guard>} />
          <Route path="/app/casa" element={<Guard roles={CUSTOMER}><HomesList /></Guard>} />
          <Route path="/app/casa/:id" element={<Guard roles={CUSTOMER}><HomeFolder /></Guard>} />
          <Route path="/app/richiesta/:slug" element={<Guard roles={CUSTOMER}><NewRequest /></Guard>} />
          <Route path="/app/richieste/:id" element={<Guard roles={CUSTOMER}><RequestDetail /></Guard>} />
          <Route path="/payment/success" element={<Guard roles={CUSTOMER}><PaymentSuccess /></Guard>} />
          <Route path="/payment/cancel" element={<Guard roles={CUSTOMER}><PaymentCancel /></Guard>} />
          <Route path="/admin" element={<Guard roles={ADMIN}><AdminDashboard /></Guard>} />
          <Route path="/admin/richieste/:id" element={<Guard roles={ADMIN}><AdminRequestDetail /></Guard>} />
          <Route path="/admin/calendario" element={<Guard roles={ADMIN}><AdminCalendar /></Guard>} />
          <Route path="/admin/team" element={<Guard roles={ADMIN}><AdminTeam /></Guard>} />
          <Route path="/admin/vetrina" element={<Guard roles={ADMIN}><AdminShowcase /></Guard>} />
          <Route path="/admin/case" element={<Guard roles={ADMIN}><HomesList /></Guard>} />
          <Route path="/admin/case/:id" element={<Guard roles={ADMIN}><HomeFolder /></Guard>} />
          <Route path="/operaio" element={<Guard roles={FIELD}><WorkerHome /></Guard>} />
          <Route path="/operaio/:id" element={<Guard roles={FIELD}><WorkerJob /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
    </LocaleProvider>
  );
}
